/*
Si label no está definido, con la funcion convertSnakeCaseToText convierto el atributo name en label
*/
const LabelControl = ({ value, label, className='', simpleLabel=false, style={} }) => {

  return (
    <>
      {
        simpleLabel ? (
          <div className={className}>
            <h6>{label} <span className="badge text-bg-secondary">{value}</span></h6>
          </div>
        ) : (
          <div role="simple-tooltip" ><b>{label}: </b>{value}</div>
        )
      }
    </>
    // 


  );
};

export default LabelControl;